import { faTag } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import Button  from '../Button/Button'
import { AllDiscountProductApi } from '../../Api/BarestSupplierServices'
import Style from './EachProductDiscount.module.css'
import { errorToast, succToast } from '../../Utils/Toast/Toast'
import { separate } from '../../Functions/NumberSeprator'

const EachProductDiscount = ({item,getProductDetail}) => {
    const[percent,setPercent]=useState(true)
    const [inputTomanValue,setInputTomanValue]=useState('')
    const [inputPercentValue,setInputPercentValue]=useState('')

    /////////////هندل کردن درصد و تومان
    const percentHandler =(e)=>{
        if(e==="درصد"){
            setPercent(true)
            setInputPercentValue('')
            setInputTomanValue('') 
        }
        else{
            setPercent(false)
            setInputPercentValue('')
            setInputTomanValue('') 
        }
    }
    /////////////// ذخیره مقدار اینپوت ها در استیت
    const amountTomanHandler =(e)=>{
        setInputTomanValue(e.target.value)
    }
    const amountPercentHandler =(e)=>{
        setInputPercentValue(e.target.value)
    }
     ////////////ارسال تخفیف ثبت شده برای محصول 
     const postAllProduct=(id)=>{
        const discount={
            id:0,
            product_id:id,
            const:inputTomanValue? parseInt(inputTomanValue):0,
            precentage:inputPercentValue ?parseInt(inputPercentValue) :0
        }
        if(inputPercentValue==='' && inputTomanValue===''){
            errorToast("لطفا مقدار تخفیف را مشخص کنید")
        }
        else{
            AllDiscountProductApi(discount,(res)=>{
                if(res.status===1){
                    succToast("با موفقیت ارسال شد") 
                    setInputPercentValue('')
                    setInputTomanValue('')
                }
                else{
                    errorToast("مشکلی پیش آمده")
                    setInputPercentValue('')
                    setInputTomanValue('') 
                }
            })
        }
        getProductDetail()
        
    }

    
    return (
        <section className={Style.discountPart}>
            <div className={Style.productInformation}>
                <div className={Style.picHolder}>
                    <img src={`https://cdn.barest.ir/product/m/${item.id}.jpg`} alt=""/>
                </div>
                <div className={Style.textPart}>
                    <h3 className={Style.name}>{item.name}</h3>
                    <div className={Style.priceHolder}>
                        <h3 className={Style.price}>{separate(item.off_price)}<span className={Style.toman}>تومان</span></h3> 
                        {item.off_price ==="0" ? null :<h3 className={Style.offPrice}><span className={Style.discount}>{separate(item.price)}</span>تومان</h3> }
                    </div>
                </div>
            </div>
            <div className={Style.discountType}>
            <h3 className={Style.text}>نوع تخفیف خود را مشخص کنید:</h3>
                <select onChange={(e)=>{percentHandler(e.target.value)}} className={Style.typeHolder}>
                <option value={"درصد"}>درصد</option>
                <option value={"وجه مالی"}>وجه مالی</option>
                </select>
            </div>
            <div>
                {
                    percent ?
                    <div className={Style.discountAmountHolder}>
                        <FontAwesomeIcon className={Style.discountIcon} icon={faTag}/>
                        <h3 className={Style.mountTextfirst}>به مقدار</h3>
                        <input value={inputPercentValue} onChange={(e)=>amountPercentHandler(e , item.id)} type={"number"} className={Style.discountInput}/>
                        <h3 className={Style.mountTextSecond}>درصد تخفیف روی محصولات اعمال شود</h3> 
                    </div>
                    :
                    <div className={Style.discountTomanHolder}>
                        <h3 className={Style.mountTextfirst}><FontAwesomeIcon className={Style.discountIconToman} icon={faTag}/>به مقدار</h3>
                        <input value={inputTomanValue} onChange={(e)=>amountTomanHandler(e,item.id)} type={"number"} className={Style.discountToman}/>
                        <h3 className={Style.mountTextSecond}>تومان تخفیف روی محصولات اعمال شود</h3> 
                    </div>
                }
            </div>
            <div className={Style.btnHolder}>
                <Button ClassBtn={"bigConfirmBtn"} ClickHandler={()=>postAllProduct(item.id)} Value={"ثبت"}/>
            </div>
        </section>
    )
}

export default EachProductDiscount
